import script from "./StudentList.vue?vue&type=script&setup=true&lang=ts"
export * from "./StudentList.vue?vue&type=script&setup=true&lang=ts"

import "./StudentList.vue?vue&type=style&index=0&id=11f7bf95&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11f7bf95"]])

export default __exports__